module.exports = __webpack_public_path__ + "img/sportsgarment.0dd905e1.png";